import { IShift } from 'models/Shift'
import { STEP_INDEX } from '@src/features/shift-post-v2/state/shift-post-v2.types'
import ROUTES, { resolveRoute } from '@src/routing/adminRoutes'
import {
  storeNavigationState,
  buildUrlWithState,
} from '@src/features/shift-post-v2/utils/navigation-state.utils'
import { IEditShiftLocationState } from '@src/features/shift-post-v2/pages/edit-shift/edit-shift.types'
import { INewEditModalFormValues } from './new-edit-modal.form'

/**
 * Reusable function to navigate to edit shift page with values and step
 * @param values - The formik values to pass to edit shift
 * @param shift - The shift object containing the id
 * @param history - The history object from useHistory hook
 * @param step - The step to navigate to (optional, defaults to ACCEPTANCE_CRITERIA)
 */
export const navigateToEditShift = (
  values: INewEditModalFormValues,
  shift: IShift,
  history: any,
  step: STEP_INDEX = STEP_INDEX.CONFIRM,
  isBusinessShifts: boolean
) => {
  const currentUrl = history.location.pathname + history.location.search

  // Store navigation state with UUID
  const navigationState: IEditShiftLocationState = {
    values,
    step,
    isBusinessShifts,
    from: currentUrl,
  }

  const stateId = storeNavigationState(navigationState)
  const baseUrl = resolveRoute(ROUTES.EDIT_SHIFT, { id: shift.id })
  const urlWithState = buildUrlWithState(baseUrl, stateId)

  history.push(urlWithState)
}
